import { LogLevel } from '@azure/msal-browser';


export const msalConfig = {
    auth: {
        clientId: window._env_.REACT_APP_MS_APP_ID, // This is the ONLY mandatory field that you need to supply.
        authority: window._env_.REACT_APP_MS_AUTH_ID, // Replace the placeholder with your tenant subdomain 
        redirectUri: window._env_.REACT_APP_MS_REDIRECT_URL, // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                // if (containsPii) {
                //     return;
                // }
                // switch (level) {
                //     case LogLevel.Error:
                //         console.error(message);
                //         return;
                //     case LogLevel.Info:
                //         console.info(message);
                //         return;
                //     case LogLevel.Verbose:
                //         console.debug(message);
                //         return;
                //     case LogLevel.Warning:
                //         console.warn(message);
                //         return;
                //     default:
                //         return;
                // }
            },
        },
    },
};
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
   scopes: []
  };
  
  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  export const graphConfig = {
      graphMeEndpoint: "Enter_the_Graph_Endpoint_Here/v1.0/me"
  };